export default {
  black3: '#4d4d4d',
  purple1: '#146eb4',
  purple2: '#115F9C',
};
